module.exports = __webpack_public_path__ + "img/tooth-healthy.48bfc68a.svg";